import { bindEvents } from '../../assets/js/helpers';

import App from '../../assets/js/app';

import AnimationController from '../../assets/js/controller/animation';
import AudioController from '../../assets/js/controller/audio';
import OverlayController from '../../assets/js/controller/overlay';


const selector = 'fixed-header';

export default class FixedHeader {

	constructor(section) {
		this.el = {
			section,
			buttons: {
				share: section.querySelector(`.${selector}__button--share button`),
				eq: section.querySelector(`.${selector}__button--eq button`),
				menu: section.querySelector(`.${selector}__button--menu button`)
			}
		};

		this.hidden = false;
		this.visible = false;

		this.animation = null;

		this.audio = AudioController.audio.background;

		this.events = bindEvents(this);

		this.addEventListeners();
		this.start();
	}

	static get selector() {
		return selector;
	}

	update(position, direction) {
		let { visible } = this;
		if (direction === 1 && position.current > 0) visible = false;
		if (direction === -1) visible = true;
		if (position.current === 0) visible = true;
		if (this.hidden) visible = false;
		if (visible !== this.visible) {
			this.visible = visible;
			return true;
		}
	}

	render() {
		this.el.section.classList[this.visible ? 'add' : 'remove']('is-visible');
		for (const id in this.el.buttons) this.el.buttons[id].dataset.cursorDisabled = !this.visible;
	}

	start() {
		this.animation = AnimationController.set({
			update: this.update.bind(this),
			render: this.render.bind(this)
		}, 'fixed header');
	}

	pause() {
		AnimationController.clear(this.animation);
	}

	show() {
		this.hidden = false;
	}

	hide() {
		this.hidden = true;
	}

	_onShareButtonClick(e) {
		e.preventDefault();
		OverlayController.open('share');
	}

	_onSpeakerButtonClick(e) {
		e.preventDefault();
		if (this.audio.paused) {
			this.audio.play();
			App.muted = false;
			AudioController.volume('background', 1);
		} else {
			App.muted = true;
			this.el.buttons.eq.classList.remove('is-playing');
			AudioController.volume('background', 0).then(() => this.audio.pause());
		}
	}

	_onMenuButtonClick(e) {
		e.preventDefault();
		OverlayController.open('nav');
	}

	_onAudioPlay() {
		this.el.buttons.eq.classList.add('is-playing');
	}

	_onAudioPause() {
		this.el.buttons.eq.classList.remove('is-playing');
	}

	addEventListeners() {
		this.el.buttons.share.addEventListener('click', this.events._onShareButtonClick);
		this.el.buttons.eq.addEventListener('click', this.events._onSpeakerButtonClick);
		this.el.buttons.menu.addEventListener('click', this.events._onMenuButtonClick);

		this.audio.addEventListener('play', this.events._onAudioPlay);
		this.audio.addEventListener('pause', this.events._onAudioPause);
	}

	removeEventListeners() {
		this.el.buttons.share.removeEventListener('click', this.events._onShareButtonClick);
		this.el.buttons.eq.removeEventListener('click', this.events._onSpeakerButtonClick);
		this.el.buttons.menu.removeEventListener('click', this.events._onMenuButtonClick);

		this.audio.removeEventListener('play', this.events._onAudioPlay);
		this.audio.removeEventListener('pause', this.events._onAudioPause);
	}

	destroy() {
		this.pause();
		this.removeEventListeners();
	}

}
